import React, { Component, Fragment } from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Input,
  Card,
  CardBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import IntlMessages from '../../../../helpers/IntlMessages';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { CardTitle } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import ticketStatus from '../../../../data/ticketStatus';
import ticketTags from '../../../../data/tags';
import formsTicketType from '../../../../data/FormsType';
import {
  gAPI_FormTickets_list,
  postAPI_Create_Ticket,
  gAPI_FormsTickets_By_Id,
  gAPI_Conversations_list,
  putAPI_Update_FormsTickets_Status,
  gAPI_Conversations_By_BotConversation,
  gAPI_TicketsRecording_id,
  postAPI_TrackEvent,
  gAPI_Users_By_Id,
  gAPI_FormsCategoryList,
} from '../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { AxiosAPI, getGroupID, getUserID } from '../../../../helpers/AxiosAPI';
import { CSVLink } from 'react-csv';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getChat, getPropertyList } from '../../../../redux/actions';
import ChatMessage from '../../../../components/chats/ChatMessage';
import { injectIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../helpers/Utils';
import ArchivedTickets from './components/Archives';
import TicketVisitor from '../../../../containers/pages/ticketVisitor';
import 'moment-timezone';
import Validation from '../../../../components/Validation';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const quillModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const StatusOptions = [
  { value: 'open', label: 'Open' },
  { value: 'Pending', label: 'Assigned' },
  { value: 'solved', label: 'Solved' },
  { value: 'Escalated', label: 'Escalated' },
  // { value: 'spam', label: 'Spam' },
  // { value: 'archived', label: 'Archived' },
];
const StatusOptionMissed = [
  { value: 'AssignBusiness', label: 'Assign to Business' },
  { value: 'AssignBookmebob', label: 'Assign to Myma.ai' },
];

let headers = [
  { label: 'Title', key: 'title' },
  { label: 'Status', key: 'status' },
  { label: 'Date', key: 'date' },
  { label: 'Messages/Notes', key: 'messageNotes' },
];
class FormTicket extends Component {
  constructor(props) {
    super(props);
    this._scrollBarRef1 = React.createRef();
    this.state = {
      startDate: moment().subtract(
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state.date != undefined
          ? this.props.location.state.date
          : 60,
        'days'
      ),
      endDate: moment(),
      hotel: {},
      embeddedDate: moment(),
      items: 20,
      tags: {},
      statuss: {},
      type:
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state.tagName != undefined
          ? this.props.location.state.tagName
          : undefined,
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      selectedChat: null,
      isLoading: false,
      isLoadmore: true,
      showLoadMoreBtn: false,
      isFiltering: false,
      ticketData: {},
      conversationData: [],
      preTicketStatus: null,
      popupProperty: null,
      ticketModalData: {},
      recordingurl: '',
      transcript: '',
      open: false,
      msg: [],
      isMissingURL: '',
      tagValue: '',
      statusValue: '',
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      selectedStatus: [],
      selectedTag: [],
      modelTicket: false,
      ticketType: null,
      ticketComments: '',
      missedResponseTitle: '',
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
      csvReport: {
        data: [],
        headers: headers,
        filename: 'missing-response.csv',
      },
      userName: '',
      userEmail: '',
      assignee: '',
      categoryList: [],
      ticketCategory: [],
      statusFilter: [],
      categoryFilter: [],
      isNewTicket: false,
      ticketTitle: '',
      ticketSelectedStatus: [],
      ticketAssignTo: '',
    };
  }

  componentDidMount() {
    var filterStatusList = [];
    StatusOptions.map((l) => filterStatusList.push({ ...l, checked: false }));
    this.setState({ statusFilter: filterStatusList });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      this.setState({ userName: res.data.fullName, userEmail: res.data.email });
    });
    const urll = window.location.pathname;
    const currentUrlName = urll.substring(urll.lastIndexOf('/') + 1);
    moment.tz.setDefault(this.props.timeZone);
    this.setState({ isLoading: true, isMissingURL: currentUrlName });
    var status = '-1';
    if (currentUrlName === 'missingresponse') {
      var selectedStatus = ticketStatus.filter((i) => i.value === 'Open');
      status = 'Open';
      this.setState({ selectedStatus: selectedStatus });
    }
    let { offset, items, startDate, endDate, type } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
    const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    this.props.getPropertyList();
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Tickets',
          email: this.props.email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
    var category = [];
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
        }&lang=${this.props.locale}`,
    }).then((res) => {
      res.data.map((l) => category.push({ ...l, checked: false }));
    });
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormTickets_list}?gid=${getGroupID()}&pid=${this.props.propertyId
        }&df=${start}&dt=${end}&tags=-1&offset=${offset}&limit=${items}&status=${status}&mr=${currentUrlName === 'missingresponse' ? true : false
        }&type=${type === undefined || type === '' ? '-1' : type}`,
    }).then(
      (res) => {
        var tag = [];
        res.data.tickets.map((i) => {
          if (i.tags.length > 0) {
            i.tags.map((k) => tag.push({ label: k, value: k }));
          }
        });
        this.setState((state) => ({
          data: [...state.data, ...res.data.tickets],
          items: 200,
          offset: 200,
          isLoading: false,
        }));
        var k = [...ticketTags, ...tag];
        var list = [...k, ...category];
        const unique = list.filter((obj, index) => {
          return index === list.findIndex((o) => obj.value === o.value);
        });
        var filtercate = [];
        unique.map((elem) => filtercate.push({ ...elem, checked: false }));
        this.setState({ categoryList: unique, categoryFilter: filtercate });

        let { data } = this.state;
        let ticketValue = [];
        var csvdata = { ...this.state.csvReport };
        if (data.length > 0) {
          data.map((elem) => {
            var status =
              StatusOptionMissed.filter((i) => i.value === elem.status).length >
                0
                ? StatusOptionMissed.filter((i) => i.value === elem.status).map(
                  (i) => i.label
                )[0]
                : elem.status;
            ticketValue.push({
              title: elem.requesterName,
              status: status,
              date: moment(elem.creationTime).format('DD/MM/YYYY hh:mm a'),
              messageNotes: elem.notes,
            });
          });
          this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
          this.handleContactClick(0, data[0].id, data[0].conversationId);
        }
        console.log(ticketValue);
        csvdata.data = ticketValue;
        console.log(csvdata);
        this.setState({ csvReport: csvdata });
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );

    // AxiosAPI({
    //   methhod: 'get',
    //   url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=-1&df=${start}&dt=${end}&tags=-1&offset=${offset}&limit=${items}&country=-1&facebookSenderName=`,
    // }).then(
    //   res => {
    //     this.setState(state => ({
    //       conversationData: [...state.data, ...res.data.conversations],
    //       items: 200,
    //       offset: 200,
    //       isLoading: false,
    //     }));
    //     let { conversationData } = this.state;
    //     if (conversationData.length > 0) {
    //       this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
    //       this.props.getChat(conversationData[0].conversationId);
    //     }
    //   },
    //   error => {
    //     this.setState({ loading: false, error, isLoading: false });
    //   }
    // );
  }

  componentWillReceiveProps(props) {
    if (
      props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
    ) {
      this.setState({ selectedChat: props.chatListApp.selectedchat });
    }
  }

  handleContactClick = (index, userId, conversationId) => {
    this.setState({ activeIndex: index });

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormsTickets_By_Id}/${userId}`,
    }).then((tres) => {
      if (conversationId !== '' && conversationId !== null) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Conversations_By_BotConversation}/${conversationId.replace(
            '|livechat',
            ''
          )}?gid=${getGroupID()}`,
        }).then((res) => {
          if (res.data.visitor && res.data.visitor.contactId) {
            console.log(
              'conversation.visitor.contactId',
              res.data.visitor.contactId
            );
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_TicketsRecording_id}?contactid=${res.data.visitor.contactId}`,
            }).then(
              (urlres) => {
                this.setState({
                  recordingurl: urlres.data.url,
                  selectedChat: res.data,
                  ticketData: tres.data,
                  transcript: urlres.data.transcript,
                });
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            this.setState({
              recordingurl: '',
              selectedChat: res.data,
              ticketData: tres.data,
              transcript: '',
            });
          }
        });
      } else {
        this.setState({
          ticketData: tres.data,
          selectedChat: undefined,
        });
      }
    });
  };
  handleChangeDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleNotes = (source, e) => {
    if (source === 'user') this.setState({ ticketNotes: e });
  };

  handleChangeSelect = (value, { name }) => {
    if (name === 'statuss') {
      var m = this.state.statusFilter.map((elem) => {
        value.map((sel) => {
          if (sel.value.toLowerCase() === elem.value.toLowerCase()) {
            elem.checked = true;
          }
        });
        return elem;
      });
      this.setState({
        selectedStatus: value,
        statusFilter: m,
      });
    } else if (name === 'tags') {
      var m = this.state.categoryFilter.map((elem) => {
        value.map((sel) => {
          if (sel.value.toLowerCase() === elem.value.toLowerCase()) {
            elem.checked = true;
          }
        });
        return elem;
      });
      this.setState({
        selectedTag: value,
        categoryFilter: m,
      });
    }
    this.setState({
      [name]: value,
    });
  };

  toggle = (item) => {
    if (item && item.id) {
      this.setState({ ticketModalData: item, selectedStatus: item.status });
    }
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  // toggleTicket = () => {
  //   var selectedProperty = this.props.usersListApp.properties !== undefined ?
  //     this.props.usersListApp.properties.filter((elem) => elem.id === this.props.propertyId).map((pro) => {
  //       return { label: pro.name, value: pro.id }
  //     })[0] : null;

  //   this.setState((prevState) => ({ modelTicket: !prevState.modelTicket, popupProperty: selectedProperty }));
  // };

  handleSubmitClick = () => {
    this.setState({
      isLoadmore: true,
      isLoading: true,
      isVisibleTicketBtn: false,
      data: [],
      selectedChat: null,
      activeIndex: -1,
      isFiltering: false,
      tagValue: '',
      statusValue: '',
    });
    let {
      items,
      hotel,
      startDate,
      endDate,
      statuss,
      tags,
      type,
      isMissingURL,
    } = this.state;
    startDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    endDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormTickets_list}?gid=${getGroupID()}&status=${statuss.length > 0 ? statuss.map((a) => a.value).join('|') : '-1'
        }&tags=${tags.length > 0 ? tags.map((a) => a.value).join('|') : '-1'
        }&pid=${this.props.propertyId
        }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&mr=${isMissingURL === 'missingresponse' ? true : false
        }&type=${type === undefined || type === '' ? '-1' : type}`,
    }).then(
      (res) => {
        this.setState({
          data: res.data.tickets,
          items: 200,
          offset: 200,
          isLoading: false,
          tagValue: tags.length > 0 ? tags.map((a) => a.value).join('|') : '-1',
          statusValue:
            statuss.length > 0 ? statuss.map((a) => a.value).join('|') : '-1',
        });
        let { data } = this.state;
        let ticketValue = [];
        var csvdata = { ...this.state.csvReport };
        if (data.length > 0) {
          data.map((elem) => {
            var status =
              StatusOptionMissed.filter((i) => i.value === elem.status).length >
                0
                ? StatusOptionMissed.filter((i) => i.value === elem.status).map(
                  (i) => i.label
                )[0]
                : elem.status;
            ticketValue.push({
              title: elem.requesterName,
              status: status,
              date: moment(elem.creationTime).format('DD/MM/YYYY hh:mm a'),
              messageNotes: elem.notes,
            });
          });
          // this.props.getChat(data[0].conversationData);
          this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
          this.handleContactClick(0, data[0].id, data[0].conversationId);
        } else {
          this.setState({ ticketData: null });
        }
        var csvdata = { ...this.state.csvReport };
        csvdata.data = ticketValue;
        this.setState({ csvReport: csvdata });
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );

    // AxiosAPI({
    //   methhod: 'get',
    //   url: `${gAPI_Conversations_list}?gid=${getGroupID()}&status=${
    //     statuss.length > 0 ? statuss.map(a => a.value).join('|') : '-1'
    //     }&tags=${
    //     tags.length > 0 ? tags.map(a => a.value).join('|') : '-1'
    //     }&pid=${
    //     hotel.length > 0 ? hotel.map(a => a.value).join('|') : '-1'
    //     }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&facebookSenderName=`,
    // }).then(
    //   res => {
    //     this.setState(state => ({
    //       conversationData: res.data.conversations,
    //       items: 200,
    //       offset: 200,
    //       isLoading: false,
    //     }));
    //     let { conversationData } = this.state;
    //     if (conversationData.length > 0) {
    //       this.props.getChat(conversationData[0].conversationId);
    //     }
    //   },
    //   error => {
    //     this.setState({ loading: false, error, isLoading: false });
    //   }
    // );
  };

  localize(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  handleTicketSubmit = () => {
    const { ticketNotes, preTicketStatus, ticketModalData } = this.state;
    var ticketStatus =
      ticketModalData.status === 'Pending'
        ? 'Assigned'
        : ticketModalData.status;
    var status =
      preTicketStatus !== null
        ? 'Status updated from ' +
        ticketStatus +
        ' to ' +
        preTicketStatus.label +
        ' by ' +
        this.state.userName +
        '<br>'
        : '';
    var assignStatus =
      this.state.assignee !== '' && preTicketStatus.label === 'Assigned'
        ? 'Assigned to ' + this.state.assignee + '<br>'
        : '';
    var note =
      ticketNotes !== ''
        ? 'Noted by ' + this.state.userName + ': <br> ' + ticketNotes
        : ticketNotes;

    const data = {
      statusNotes: status + assignStatus + note,
      status:
        (preTicketStatus && preTicketStatus.value) ||
        this.localize(ticketModalData.status),
      updator: this.state.userName,
      assignEmail: this.state.assignee,
    };

    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_FormsTickets_Status}/${ticketModalData.id}`,
      data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          this.setState({ msg: res.data.Messages });
          this.setState({ open: true });
        } else {
          this.toggle();
          var getIndex = this.state.data.findIndex(
            (obj) => obj.id === ticketModalData.id
          );
          this.handleContactClick(
            getIndex,
            ticketModalData.id,
            ticketModalData.conversationId
          );
          this.setState({
            ticketNotes: '',
            assignee: '',
            ticketModalData: null,
          });
          this.handleSubmitClick();
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  handleLoadMore = () => {
    this.setState({
      isLoadmore: true,
      isLoading: true,
    });
    const urll = window.location.pathname;
    const currentUrlName = urll.substring(urll.lastIndexOf('/') + 1);

    let {
      offset,
      items,
      startDate,
      endDate,
      isMissingURL,
      statuss,
      tags,
      type,
    } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
    const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormTickets_list}?gid=${getGroupID()}&pid=${this.props.propertyId
        }&df=${start}&dt=${end}&tags=${tags.length > 0 ? tags.map((a) => a.value).join('|') : '-1'
        }&offset=${0}&limit=${items}&status=${statuss.length > 0 ? statuss.map((a) => a.value).join('|') : '-1'
        }&mr=${currentUrlName === 'missingresponse' ? true : false}&type=${type === undefined || type === '' ? '-1' : type
        }`,
    }).then(
      (res) => {
        // setTickets(res.data.tickets);
        // setLoading(false);
        this.setState((state) => ({
          data: [...state.data, ...res.data.tickets],
          items: 200,
          offset: 200,
          isLoading: false,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };
  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };
  // handleCreateTicketSubmit = () => {
  //   const { ticketComments, missedResponseTitle, ticketType, popupProperty, selectedChat } = this.state;
  //   let tickets = ['Missing Bot Response'];
  //   ticketType && ticketType.map((ticket) => tickets.push(ticket.value));

  //   const data = {
  //     notes: ticketComments,
  //     tags: tickets,
  //     creator: 'Dashboard',
  //     Source: 'BobDashboard',
  //     conversationId: selectedChat.botConversationId,
  //     propertyId: popupProperty && popupProperty.value,
  //     groupId: selectedChat.groupId,
  //     type: "MissingResponses"
  //   };
  //   if (missedResponseTitle !== null && missedResponseTitle !== "") {
  //     data.requesterName = missedResponseTitle;
  //   }
  //   AxiosAPI({
  //     method: 'post',
  //     url: `${postAPI_Create_Ticket}`,
  //     data,
  //   })
  //     .then(() => {
  //       this.toggleTicket();
  //       this.handleSubmitClick();
  //     })
  //     .catch((err) => {
  //       console.log('err', err);
  //     });
  // };
  render() {
    const {
      usersListApp: { properties },
    } = this.props;

    const {
      selectedChat,
      startDate,
      endDate,
      ticketData,
      modal,
      preTicketStatus,
      ticketModalData,
      selectedStatus,
      selectedTag,
      modelTicket,
      ticketType,
      popupProperty,
    } = this.state;
    const statusList =
      ticketModalData &&
      ticketModalData.status &&
      [...StatusOptions, ...StatusOptionMissed].filter(
        (i) => i.value === ticketModalData.status
      );

    const preFillStatus = ticketModalData &&
      ticketModalData.status && {
      value:
        statusList.length > 0
          ? statusList.map((i) => i.value)[0]
          : ticketModalData.status,
      label:
        statusList.length > 0
          ? statusList.map((i) => i.label)[0]
          : ticketModalData.status,
    };

    return (
      <Fragment>
        <Row>
          {this.state.isFiltering && (
            <Fragment>
              <Card
                style={{
                  position: 'absolute',
                  zIndex: '1',
                  top: '7.7rem',
                  marginLeft: '0.4rem',
                  boxShadow:
                    '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
                }}
              >
                <CardBody>
                  <Colxx xxs="12" md="12" className="mb-2">
                    <DatePicker
                      selected={startDate ? new Date(startDate) : null} // ensure Date object
                      onChange={this.handleChangeDate}
                      placeholderText="Start Date"
                      dateFormat="dd/MM/yyyy"
                    />
                  </Colxx>
                  <Colxx xxs="12" md="12" className="mb-2">
                    <DatePicker
                      selected={endDate ? new Date(endDate) : null}
                      onChange={this.handleChangeEndDate}
                      placeholderText="End Date"
                      dateFormat="dd/MM/yyyy"
                    />
                  </Colxx>
                  {/* <Colxx xxs="12" md="3" className="mb-2">
                <Select
                  // components={{ Input: CustomSelectInput }}
                  isMulti={true}
                  placeholder="Select properties"
                  className="react-select"
                  classNamePrefix="react-select"
                  name="hotel"
                  onChange={this.handleChangeSelect}
                  options={
                    properties
                      ? reactSelectOptionDiffrentPro(
                        properties,
                        true,
                        'id',
                        'name',
                        'All Propeties'
                      )
                      : []
                  }
                />
              </Colxx> */}
                  <Colxx xxs="12" md="12" className="mb-2">
                    <Select
                      isMulti={true}
                      // components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="statuss"
                      placeholder="Select Status"
                      onChange={this.handleChangeSelect}
                      options={
                        this.state.isMissingURL !== 'missingresponse'
                          ? ticketStatus
                          : [...ticketStatus, ...StatusOptionMissed]
                      }
                      value={selectedStatus}
                    />
                  </Colxx>
                  <Colxx
                    xxs="12"
                    md="12"
                    className="mb-2"
                    style={{
                      display:
                        this.state.isMissingURL !== 'missingresponse'
                          ? 'block'
                          : 'none',
                    }}
                  >
                    <Select
                      isMulti={true}
                      // components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="tags"
                      placeholder="Select Categories"
                      onChange={this.handleChangeSelect}
                      options={this.state.categoryList}
                      value={selectedTag}
                    />
                  </Colxx>
                  {this.state.isMissingURL !== 'missingresponse' && (
                    <Colxx xxs="12" md="12" className="mb-2">
                      <Input className='input_sty'
                        type="select"
                        value={this.state.type}
                        name="type"
                        onChange={this.handleInputChange}
                      >
                        <option value="-1">All Types</option>
                        {formsTicketType.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </Input>
                    </Colxx>
                  )}
                  <Colxx xxs="12" md="12" className="mb-2 mt-3">
                    <Button
                      size="xs"
                      color="primary"
                      className="mb-2 mr-2"
                      onClick={() => this.handleSubmitClick()}
                    >
                      <IntlMessages id="forms.submit" />
                    </Button>
                    <Button
                      size="xs"
                      color="secondary"
                      className="mb-2 mr-2 ml-2"
                      onClick={() => this.setState({ isFiltering: false })}
                    >
                      Cancel
                    </Button>
                    {this.state.isMissingURL === 'missingresponse' && (
                      <Fragment>
                        {this.state.csvReport.data.length > 0 ? (
                          <Button size="xs" color="dark" className="mb-2">
                            <CSVLink {...this.state.csvReport}>
                              <span style={{ color: 'white' }}>
                                Download CSV
                              </span>
                            </CSVLink>
                          </Button>
                        ) : (
                          <Button size="xs" color="dark" className="mb-2">
                            <span style={{ color: 'white' }}>Download CSV</span>
                          </Button>
                        )}
                      </Fragment>
                    )}
                  </Colxx>
                </CardBody>
              </Card>
            </Fragment>
          )}
        </Row>

        {/* Update Ticket Modal */}
        <Row>
          <Colxx xxs="12">
            <Modal isOpen={modal} toggle={this.toggle} size="lg">
              <ModalHeader toggle={this.toggle}>
                <IntlMessages id="Ticket Details" />
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Colxx xxs="12">
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Notes" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <ReactQuill
                          theme="snow"
                          onChange={(content, delta, source) =>
                            this.handleNotes(source, content)
                          }
                          modules={quillModules}
                          formats={quillFormats}
                          name="ticketNotes"
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="pages.status" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="preTicketStatus"
                          value={preTicketStatus || preFillStatus}
                          onChange={this.handleChangeSelect}
                          options={
                            this.state.isMissingURL !== 'missingresponse'
                              ? StatusOptions
                              : [...StatusOptions, ...StatusOptionMissed]
                          }
                        />
                      </Colxx>
                    </Row>
                    {preTicketStatus !== null &&
                      preTicketStatus.value === 'Pending' && (
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>Assignee</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Input className='input_sty'
                              name="assignee"
                              onChange={this.handleInputChange}
                              type="text"
                              placeholder="Enter assinee email"
                            />
                          </Colxx>
                        </Row>
                      )}
                    <Row>
                      <Colxx xxs="3">
                        <Button
                          color="primary"
                          className="mb-2"
                          onClick={this.handleTicketSubmit}
                        >
                          <IntlMessages id="forms.submit" />
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </ModalBody>
            </Modal>
          </Colxx>
        </Row>

        <Row>
          <Colxx
            xxs="12"
            md="4"
            className="mb-2 col-sm-12 col-md-4"
            style={{ paddingLeft: '5px', paddingRight: '5px' }}
          >
            <Card>
              <CardBody className="mt-0">
                <Button
                  size="xs"
                  color="primary"
                  className="mb-4 mr-5"
                  onClick={() =>
                    this.setState({ isFiltering: !this.state.isFiltering })
                  }
                >
                  <div className="d-flex">
                    <FontAwesomeIcon icon={faFilter} className="fa mr-1" />{' '}
                    <IntlMessages id="menu.show-filter" />{' '}
                    <div className="ml-1" style={{ marginTop: '2px' }}>
                      {this.state.isFiltering ? (
                        <i className="simple-icon-arrow-up p-1"></i>
                      ) : (
                        <i className="simple-icon-arrow-down p-1"></i>
                      )}
                    </div>
                  </div>
                </Button>
                <ArchivedTickets
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  offset={this.state.offset}
                  items={this.state.items}
                  isLoading={this.state.isLoading}
                  data={this.state.data}
                  activeIndex={this.state.activeIndex}
                  handleContactClick={this.handleContactClick}
                  propertyId={this.props.propertyId}
                  isMissingUrl={
                    this.state.isMissingURL === 'missingresponse' ? true : false
                  }
                  tagValue={this.state.tagValue}
                  statusValue={this.state.statusValue}
                  handleLoadMore={this.handleLoadMore}
                  handleMaskClick={this.handleMaskClick}
                  isMasked={this.state.isMasked}
                  categoryList={this.state.categoryList}
                />
              </CardBody>
            </Card>
          </Colxx>
          {selectedChat !== undefined &&
            selectedChat !== null &&
            selectedChat !== '' && (
              <Colxx
                xxs="12"
                md="4"
                className="mb-2 col-sm-12 col-md-4"
                style={{ paddingLeft: '5px', paddingRight: '5px' }}
              >
                <Card
                  className="cardHeightTickets con-ticket-height"
                  style={{
                    overflow: 'scroll',
                    backgroundColor: selectedChat
                      ? `${selectedChat.colours.botBackground}`
                      : '#fff',
                  }}
                >
                  <CardBody>
                    <div className="scroll  ">
                      {selectedChat && (
                        // <PerfectScrollbar
                        //   className="scroll box-height"
                        //   ref={(ref) => {
                        //     this._scrollBarRef = ref;
                        //   }}
                        //   containerRef={(ref) => {
                        //     this._scrollBarRef = ref;
                        //   }}
                        //   option={{ suppressScrollX: true, wheelPropagation: true }}
                        // >
                        <div>
                          {selectedChat.messages != null &&
                            selectedChat.messages.length > 0 &&
                            selectedChat.messages.map((item, index) => {
                              // const sender = allContacts.find(x => x.id === item.sender);
                              return (
                                <ChatMessage
                                  key={index}
                                  sender={item.sender}
                                  item={item}
                                  avatar={selectedChat.avatar}
                                  colors={selectedChat.colours}
                                />
                              );
                            })}
                        </div>
                        // </PerfectScrollbar>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
            )}
          <Colxx
            xxs="12"
            md="4"
            className="mb-2 col-sm-12 col-md-4"
            style={{ paddingLeft: '5px', paddingRight: '5px' }}
          >
            {ticketData && ticketData.id && (
              <TicketVisitor
                item={ticketData}
                handleStatusClicked={(item) => this.toggle(item)}
                conversation={selectedChat}
                recordingurl={this.state.recordingurl}
                transcript={this.state.transcript}
                handleMaskClick={this.handleMaskClick}
                isMasked={this.state.isMasked}
                //toggleTicket={this.toggleTicket}
                isMissingUrl={
                  this.state.isMissingURL === 'missingresponse' ? true : false
                }
              />
            )}
          </Colxx>
        </Row>

        {/* <Row>
          <Colxx xxs="12">
            <Modal isOpen={modelTicket} toggle={this.toggleTicket} size="lg">
              <ModalHeader toggle={this.toggleTicket}>
                <IntlMessages id="Ticket Details" />
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Colxx xxs="12">
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label><IntlMessages id="Ticket Type" /></label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          isMulti={true}
                          className="react-select"
                          classNamePrefix="react-select"
                          name="ticketType"
                          value={ticketType}
                          onChange={this.handleChangeSelect}
                          options={this.state.isMissingURL !== 'missingresponse' ?
                            TicketTypeOptions : [...TicketTypeOptions, ...TicketTypeOptionMissed]}
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label><IntlMessages id="Property" /></label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          isDisabled={true}
                          className="react-select"
                          classNamePrefix="react-select"
                          name="popupProperty"
                          value={properties && popupProperty}
                          onChange={this.handleChangeSelect}
                          options={
                            properties
                              ? reactSelectOption(properties, false)
                              : []
                          }
                        />
                      </Colxx>
                    </Row>
                    {ticketType !== null && ticketType.length > 0 &&
                      ticketType.filter((i) => i.value === "Missed Response - Business to action" ||
                        i.value === "Missed Response - Myma.ai to action").length > 0 &&
                      (
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>
                              <IntlMessages id="missed-response.missed-response-title" />
                            </label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Input
                              name="missedResponseTitle"
                              onChange={this.handleInputChange}
                              placeholder="Missed Response Title"
                            />
                          </Colxx>
                        </Row>
                      )}
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Comments" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Input
                          name="ticketComments"
                          onChange={this.handleInputChange}
                          type="textarea"
                          placeholder="Comments"
                        />
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="3">
                        <Button
                          color="primary"
                          className="mb-2"
                          onClick={this.handleCreateTicketSubmit}
                        >
                          <IntlMessages id="forms.submit" />
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </ModalBody>
            </Modal>
          </Colxx>
        </Row> */}
        <Validation
          open={this.state.open}
          messages={this.state.msg}
          toggle={() => {
            this.setState({ open: false });
          }}
        ></Validation>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ chatListApp, usersListApp, settings }) => {
  const { propertyId, timeZone, locale, email } = settings;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    getPropertyList,
    getChat,
  })(FormTicket)
);
